let errorCount = 0;
const MAX_ERRORS = 3;
const ERROR_WINDOW = 5000; // 5 seconds
let lastErrorTime = 0;

export function initAuthErrorHandler() {
  if (typeof window === 'undefined') return;

  const originalFetch = window.fetch;

  window.fetch = async function(...args) {
    try {
      const response = await originalFetch.apply(this, args);

      // Check for session_not_found errors
      if (response.status === 403 && args[0].toString().includes('supabase.co/auth')) {
        const now = Date.now();

        // Reset counter if errors are spaced out
        if (now - lastErrorTime > ERROR_WINDOW) {
          errorCount = 0;
        }

        lastErrorTime = now;
        errorCount++;

        // Clone response to read body without consuming it
        const clonedResponse = response.clone();
        try {
          const body = await clonedResponse.text();
          if (body.includes('session_not_found') || body.includes('Session from session_id')) {
            console.warn(`[Auth] Session error detected (${errorCount}/${MAX_ERRORS})`);

            if (errorCount >= MAX_ERRORS) {
              console.error('[Auth] Too many session errors, clearing all auth data');

              // Clear all storage
              const keysToRemove = [];
              for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (key && key.includes('supabase')) {
                  keysToRemove.push(key);
                }
              }
              keysToRemove.forEach(key => localStorage.removeItem(key));
              sessionStorage.clear();
              document.cookie.split(";").forEach((c) => {
                document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
              });

              errorCount = 0;

              // Redirect to login after a short delay
              setTimeout(() => {
                if (window.location.pathname !== '/login') {
                  window.location.href = '/login';
                }
              }, 500);
            }
          }
        } catch (e) {
          // Body already consumed or not readable, continue
        }
      } else if (response.ok) {
        // Reset error count on successful requests
        errorCount = 0;
      }

      return response;
    } catch (error) {
      throw error;
    }
  };
}
